// constants.js
export const API_BASE_URL = 'https://www.portal.genmai.ai';
//export const API_BASE_URL = 'http://10.0.0.176:5000';
